import { IHttpRepository } from "../../interfaces/IHttpRepository";
import { HttpRepository } from "./_HttpRepository";

export interface IOrderDetailValidation {
  ProductId: string;
  Quantity: number;
  Value: number;
  TotalValue: number;
}

export interface IOrderValidationRequest {
  Id: string;
  OwnerId: string;
  OrderDate: string;
  DeviceId: string;
  Details: IOrderDetailValidation[];
}

export interface IMeepResponseError {
  key: string;
  messages: string[];
}

export interface IMeepResponseErrors {
  message: string;
  errors: IMeepResponseError[];
}

export interface IInventoryRepository {
  validateOrderAsync(request: IOrderValidationRequest): Promise<void>;
}

export const InventoryRepository = (): IInventoryRepository => {
  const httpRepository: IHttpRepository = HttpRepository();

  const validateOrderAsync = async (
    request: IOrderValidationRequest
  ): Promise<void> => {
    await httpRepository.postAsync<IOrderValidationRequest, void>(
      "/vendas/BeginOrderValidation",
      request
    );
  };

  return { validateOrderAsync };
};
